"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react2 = require("@emotion/react");

var _theme = _interopRequireWildcard(require("../../theme/theme"));

var _templateObject;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Panel = function Panel(_ref) {
  var className = _ref.className,
      children = _ref.children,
      _ref$as = _ref.as,
      as = _ref$as === void 0 ? "section" : _ref$as,
      _ref$position = _ref.position,
      position = _ref$position === void 0 ? "fixed" : _ref$position,
      _ref$placement = _ref.placement,
      placement = _ref$placement === void 0 ? "top" : _ref$placement,
      _ref$padding = _ref.padding,
      padding = _ref$padding === void 0 ? "2" : _ref$padding;

  var space = _theme.MAP_SPACE[String(padding)];

  var shadow = "";

  if (placement === "top") {
    shadow = "0 2px 7px -2px rgba(0,0,0,.6), 0 1px 18px -4px rgba(0,0,0,.3)";
  }

  if (placement === "bottom") {
    shadow = "0 -2px 7px -3px rgba(0,0,0,.6), 0 -1px 18px -6px rgba(0,0,0,.3)";
  }

  return (0, _react2.jsx)(_react2.ClassNames, null, function (_ref2) {
    var css = _ref2.css,
        cx = _ref2.cx;
    return /*#__PURE__*/_react["default"].createElement(as, {
      className: cx(className, css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n                position: ", ";\n                left: 0;\n                right: 0;\n                top: ", ";\n                bottom: ", ";\n\n                z-index: 2000;\n                padding: ", ";\n                border: ", " solid ", ";\n                border-radius: ", ";\n\n                color: ", ";\n                font-size: ", ";\n                font-family: ", ";\n\n                background: ", ";\n                box-shadow: ", ";\n              "])), position, placement === "top" ? "0" : "auto", placement === "bottom" ? "0" : "auto", space, _theme["default"].borderSizeRegular, _theme["default"].colorDarkTemp, _theme["default"].radiusRegular, _theme["default"].colorDarkTemp, _theme["default"].fontSizeN, _theme["default"].fontFamily, _theme["default"].colorLightTemp, shadow))
    }, children);
  });
};

Panel.propTypes = {
  className: _propTypes["default"].string,
  children: _propTypes["default"].node.isRequired,
  as: _propTypes["default"].string,
  padding: _propTypes["default"].oneOf(_theme.SPACE_TYPES),
  position: _propTypes["default"].oneOf(_theme.POSITION_TYPES),
  placement: _propTypes["default"].oneOf(_theme.PLACEMENT_Y_TYPES)
};
var _default = Panel;
exports["default"] = _default;